const commandList = {
  "": {
    response: "",
  },
  help: {
    response:
      "Available commands: <br> 'help' - shows this message<br> 'whoami' - info about me<br> 'social' - social media links <br> 'contact' - contact informations<br> 'clear' - clear console",
  },
  whoami: {
    response:
      "Hello! My name is Peter Zdravecký and im intrested in Programming.",
  },
  social: {
    response:
      "Github: <a href='https://github.com/Monnte' target='_blank'>https://github.com/Monnte</a>",
  },
  contact: {
    response:
      "Email adress: <a href='mailto:zdravecky.zdravecky@gmail.com'>zdravecky.zdravecky@gmail.com</a>",
  },
};

export default commandList;
